import script from "./logoutPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./logoutPopup.vue?vue&type=script&setup=true&lang=ts"

import "./logoutPopup.vue?vue&type=style&index=0&id=356bbc51&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356bbc51"]])

export default __exports__